import { useEffect, useState } from 'react';

/**
 * The phone layout. The same width the stylesheet uses, so what the screen
 * shows fewer of (book levels, trades, rows before a scroll) and what the
 * stylesheet tightens always agree.
 */
export const NARROW = '(max-width: 720px)';

/**
 * How much of the book a phone shows at once, on both trading screens: the
 * browser's and the one inside Telegram. Everything else is one tap away.
 */
export const PHONE_LEVELS = 4;
export const PHONE_TRADES = 3;
/** Rows of your own orders before the rest fold away, or the list scrolls. */
export const PHONE_ROWS = 3;

export function useNarrow(): boolean {
  const ask = (): boolean => typeof matchMedia === 'function' && matchMedia(NARROW).matches;
  const [narrow, setNarrow] = useState(ask);
  useEffect(() => {
    if (typeof matchMedia !== 'function') return;
    const query = matchMedia(NARROW);
    const on = (): void => {
      setNarrow(query.matches);
    };
    on();
    query.addEventListener('change', on);
    return () => {
      query.removeEventListener('change', on);
    };
  }, []);
  return narrow;
}
